// @flow
import React from 'react';

import { t } from 'Src/i18n';
import { AlternativeSuggestionCriteria } from 'Components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeSuggestionCriteria';
import { AlternativeSuggestions } from 'Components/widgets/alternative-proposals/alternative-suggestions/AlternativeSuggestions';
import { useTracking } from 'Tracking/tracking-api/useTracking';

type Props = {|
  durations: $ReadOnlyArray<DurationSuggestions>,
  onSelectNewDuration: ({ proposalIds: $ReadOnlyArray<string>, duration: number }) => void,
  categoryGA?: string,
|};

export const AlternativeDurationSuggestions = ({
  durations,
  onSelectNewDuration,
  categoryGA,
}: Props) => {
  const track = useTracking({
    categoryGA: 'resort',
    actionGA: 'checkPriceKO',
  });

  return (
    <AlternativeSuggestions title={t('booking.counterProposalPopIn.durationsLabel')}>
      {durations.map(suggestion => {
        const { duration } = suggestion.data;

        return (
          <AlternativeSuggestionCriteria
            key={duration}
            title={
              <div className="text-md mb-1">
                {t('booking.counterProposalPopIn.durationLabel')}{' '}
                <span className="font-bold text-blue text-lg">
                  {t('booking.counterProposalPopIn.durationsSuggestions', { duration })}
                </span>
              </div>
            }
            buttonLabel={t('booking.counterProposalPopIn.checkPriceLabelDuration')}
            suggestion={{
              ...suggestion.data,
              price: {
                total: suggestion.data.price.total.formattedValue,
              },
            }}
            onSubmit={() => {
              onSelectNewDuration({ proposalIds: suggestion.ids, duration });
              track({
                labelGA: 'duration_check',
              });
            }}
            categoryGA={categoryGA}
          />
        );
      })}
    </AlternativeSuggestions>
  );
};
